"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.logolink-container {\n  width: 250px;\n  max-width: 100%; }\n  .logolink-container a,\n  .logolink-container div {\n    display: flex;\n    gap: 10px;\n    cursor: pointer;\n    width: auto;\n    max-width: 100%; }\n  .logolink-container img {\n    flex: none; }\n  .logolink-container a {\n    text-decoration: none; }\n  .logolink-container a:hover img > p {\n    color: #4c4c4c; }\n  .logolink-container p {\n    padding-top: 7px; }\n";
  const fileName = "LogoLink_LogoLink";
  const element = document.querySelector("style[data-sass-component='LogoLink_LogoLink']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const variants = exports.variants = {
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL'
};
const Wrapper = _ref => {
  let {
    children,
    variant,
    href,
    to,
    onClick
  } = _ref;
  return variant === variants.INTERNAL ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    onClick: onClick,
    to: to || href,
    style: {
      maxWidth: '100%'
    }
  }, children) : /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    href: href
  }, children);
};
const LogoLink = _ref2 => {
  let {
    variant,
    href,
    to,
    src,
    onClick,
    width,
    height,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "logolink-container sia-padding-04-bottom"
  }, /*#__PURE__*/_react.default.createElement(Wrapper, _extends({
    variant: variant,
    href: href,
    to: to,
    onClick: onClick
  }, rest), /*#__PURE__*/_react.default.createElement("img", {
    src: src,
    alt: "Logo",
    style: {
      width,
      height
    }
  })));
};
LogoLink.propTypes = {
  variant: _propTypes.default.oneOf(Object.values(variants)),
  href: _propTypes.default.string,
  src: _propTypes.default.string.isRequired,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  to: _propTypes.default.string,
  onClick: _propTypes.default.func
};
var _default = exports.default = LogoLink;